function dismiss(slug) {
    if (!slug) return;

    $.ajax(`/dialogs/${slug}/dismiss/`);
}

function enable(slug) {
    if (!slug) return;

    $.ajax(`/dialogs/${slug}/dismiss/`);
}

// TODO: Factor this out
function setup(dialogRevealFunc) {
    function setupDismissableDialogs() {
        $(".dd-reveal").on("click", function(ev) {
            ev.preventDefault();
            var slug = $(this).data("slug");
            var $dd = $('.dialog.dialog-row[data-slug="' + slug + '"]');

            $dd.css("display") === "none" ? $dd.fadeIn(100) : $dd.fadeOut(100);
        });

        if (dialogRevealFunc) {
            $(".dialog-reveal").on("click", dialogRevealFunc);
        }
    }

    function setupToggleDialogs() {
        $(".dd-reveal").on("click", function(ev) {
            ev.preventDefault();
            var slug = $(this).data("slug");
            var $dd = $('.toggle-dialog[data-slug="' + slug + '"]');

            var func = $dd.is(":hidden") ? enable : dismiss;
            func(slug);

            var self = this;

            $.fn.fadeThenSlideToggle = function(speed, easing, callback) {
                speed = speed || 350;
                easing = easing || "swing";
                if (this.is(":hidden")) {
                    callback();
                    return this.slideDown(speed, easing).fadeTo(speed / 2, 1, easing);
                } else {
                    return this.fadeTo(speed / 2, 0, easing).slideUp(speed, easing, callback);
                }
            };

            $dd.fadeThenSlideToggle(null, null, function() {
                if ($(self).hasClass("dd-reveal-toggle")) {
                    $(self).toggle();
                }
            });
        });

        $(".dd-reveal-dismiss").on("click", function() {
            var slug = $(this).data("slug");
            $(document)
                .find('.dd-reveal[data-slug="' + slug + '"]')
                .trigger("click");
        });
    }

    setupDismissableDialogs();
    setupToggleDialogs();
}

module.exports.dismiss = dismiss;
module.exports.enable = enable;
module.exports.setup = setup;
